<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading"
				class="elevation-1" disable-pagination hide-default-footer item-key="id"
				loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 200px;" class="mr-1">
								<v-select :items="selectClassList" v-model="query.classId" item-text="className"
									item-value="id" label="班级" dense outlined clearable></v-select>
							</div>
							
							<div style="width: 150px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="申请开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
								
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="申请结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
								
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id"
									label="请假状态" dense outlined></v-select>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
						

					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.classDate="{item}">
					<span>{{item.classDate}}</span>
					<span class="ml-1">{{item.weekAtName}}</span>
					<span class="ml-1">{{item.timeFrom}}</span>
					<span>-</span>
					<span>{{item.timeTo}}</span>
				</template>
				<template v-slot:item.status="{item}">
					<span v-if="item.status==='1'">待审核</span>
					<span v-if="item.status==='2'" style="color:green">已批准</span>
					<span v-if="item.status==='3'" style="color:red">已拒绝</span>
					<span v-if="item.status==='0'" style="color:dimgrey">已取消</span>
				</template>
				
				<template v-slot:item.action="{item}">
					<v-btn :disabled="item.status !== '1'" color="info" small @click="approve(item)">
						同意
					</v-btn>
					<v-btn class="ml-1" :disabled="item.status !=='1'" color="error" small @click="showRefuseDialog(item)">
						拒绝
					</v-btn>
					<v-btn class="ml-1" color="warning" :disabled="item.status =='3' || item.status == '0'" small @click="cancel(item)">
						取消
					</v-btn>
					
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 班级详情页 -->
		<absenceRefuse :show="refuseDialog.show" :absenceModel="refuseDialog.absenceModel" @cancel="refuseDialog.show=false" @success="refuseSuccess"></absenceRefuse>

	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	import absenceRefuse from "../../../components/absence_refuse.vue"
	export default {
		name: "class-record-detail-list",
		components:{absenceRefuse},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '请假记录',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '上课时间',
							value: 'classDate',
							sortable: false,	
						},
						{
							text: '请假学员',
							value: 'studentName',
							sortable: false,
						},
						{
							text: '课程',
							value: 'courseName',
							sortable: false,
						},
						{
							text: '班级',
							value: 'className',
							sortable: false,
						},
						{
							text: '申请时间',
							value: 'createAt',
							sortable: false,
										
						},
						{
							text: '状态',
							value: 'status',
							sortable: false,
										
						},
						{
							text: '审核时间',
							value: 'approveAt',
							sortable: false,
										
						},
						{
							text: '审核结果',
							value: 'approveMemo',
							sortable: false,
										
						},
						{
							text: '操作',
							value: 'action',
							align:'center',
							sortable: false
						},
					],
					list: [],
				},
				selectCourseList: [], //选择课程数据源
				selectClassList: [], //选择课程数据源
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "待审核"
					},
					{
						id: "2",
						statusName: "已批准"
					},
					{
						id: "3",
						statusName: "已拒绝"
					},
					{
						id: "0",
						statusName: "已取消"
					},
				],
				
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					shopId: "",
					classId: "",
					status: "",
				},
				refuseDialog:{
					absenceModel:null,
					show:false,
				}
			}
		},
		created() {
			const shopId = utils.getCurrentShopId();
			
			this.getClassListForSelect(shopId);
			
			this.getTableDataList();
		},
		methods: {
			
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			showRefuseDialog(item){
				this.refuseDialog.absenceModel = item;
				this.refuseDialog.show = true;
			},
			refuseSuccess(){
				this.refuseDialog.show = false;
				this.getTableDataList();
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				const shopId = utils.getCurrentShopId();

				let url = `/edu/absence/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.classId) {
					url += "&classId=" + this.query.classId;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				
				this.axios.get(url).then(response => {

					console.log(response);

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			approve(item){
				// 批准请假
				const that = this;
				const shopId = utils.getCurrentShopId();
				let url = `/edu/absence/approve/${item.id}`;
				if (shopId) {
					url += `?shopId=${shopId}`;
				}
				
				console.log(url);
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				});
				
			},
			cancel(item){
				// 取消请假
				const that = this;
				const shopId = utils.getCurrentShopId();
				let url = `/edu/absence/cancel/${item.id}`;
				if (shopId) {
					url += `?shopId=${shopId}`;
				}
				
				console.log(url);
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				});
			},
			getClassListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/class/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCourseListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/course/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		

		}
	}
</script>

<style>
</style>
